import { styled } from '@material-ui/core/styles';

import { Image } from 'shared/components/image/Image';

export const Icon = styled(Image)({
  margin: '0 auto',
});
